import { DeviceModel, DeviceModelPatch } from 'src/app/model/device-model';

/**
 * Applies device-models Patches when BoardType matches.
 * Currently only Condition.BoardType is supported (model id + BoardType).
 */
export function resolveDeviceModelLabels(
	deviceModel: DeviceModel | undefined | null,
	boardType: string | undefined | null,
): Pick<DeviceModel, 'ProductName' | 'Description'> {
	const productName = deviceModel?.ProductName ?? '';
	const description = deviceModel?.Description ?? '';

	if (!deviceModel?.Patches?.length || boardType === undefined || boardType === null || boardType === '') {
		return { ProductName: productName, Description: description };
	}

	const boardTypeNormalized = String(boardType);
	const matched = deviceModel.Patches.find(
		(patch: DeviceModelPatch) => patch?.Condition?.BoardType !== undefined
			&& String(patch.Condition.BoardType) === boardTypeNormalized
	);

	if (!matched?.Patch) {
		return { ProductName: productName, Description: description };
	}

	return {
		ProductName: matched.Patch.ProductName ?? productName,
		Description: matched.Patch.Description ?? description,
	};
}
